/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import androidFilled from '@iconify/icons-ant-design/android-filled';
// material
import { alpha, styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
import NaturePeopleIcon from '@material-ui/icons/NaturePeople';
import CountUp from 'react-countup';
import TokenDecoder from '../../../helpers/TokenDecoder';
import BusinessIcon from '@mui/icons-material/Business';

// utils
import { fShortenNumber } from '../../../utils/formatNumber';
import VPUDashboardService from './VPUDashboardService';


// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
    boxShadow: 'none',
    textAlign: 'center',
    padding: theme.spacing(5, 0),
    color: theme.palette.primary.darker,
    backgroundColor: theme.palette.primary.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
    margin: 'auto',
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    width: theme.spacing(8),
    height: theme.spacing(8),
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.dark,
    backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
        theme.palette.primary.dark,
        0.24
    )} 100%)`
}));

// ----------------------------------------------------------------------

export default function OrderCountSKUwiseVPU() {

    // const OpID = parseInt(TokenDecoder.getGroupFactoryToken().factory);

    const [productCount, setProductCount] = useState(0);

    async function getYesterdayOrderCountSKU() {
        const response = await VPUDashboardService.getYesterdayOrderCountSKU();
        if (response.length > 0) {
            setProductCount(response[0].productCount);
        }
    }
    useEffect(() => {
        getYesterdayOrderCountSKU();
    }, [])

    return (
        <RootStyle>
            <IconWrapperStyle>
                <BusinessIcon fontSize='large' width={50} height={60} />
            </IconWrapperStyle>
            <Typography variant="h3"><CountUp end={productCount} /></Typography>
            <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
                Customer Order Count (SKU)
            </Typography>
        </RootStyle>
    );
}
